import { ROLES } from "../../../constants/user";

class User {

    static validateRol(authorities) {
        let isViewer = false;

        authorities.length && authorities.forEach((auth) => {
            if (auth.name === ROLES.VIEWER) {
                isViewer = true;
            }
        })
        return isViewer;
    }
}

export default User;



// WEBPACK FOOTER //
// ./src/lib/utils/transforms/user.js